<template>
    <layout-internal-container>
        <div class="flex flex-col md:flex-row justify-between w-full items-start md:items-end gap-4">
            <div class="flex flex-col gap-2">
                <span class="text-sm text-light font-medium">
                    Here's all your webinar and mentoring schedule reminders
                </span>
            </div>
        </div>

        <a-calendar mode="month" v-model:value="value" @change="actionDate('custom', value)">
            <template #headerRender>
                <div class="flex flex-col sm:flex-row justify-between w-full md:items-center pb-6 gap-4">
                    <div class="flex flex-row gap-4">
                        <div class="flex flex-row gap-2">
                            <div class="cursor-pointer border w-fit rounded-md px-2 py-2" @click="actionDate('prev')">
                                <IconChevronLeft :size="18" />
                            </div>
                            <div class="cursor-pointer border w-fit rounded-md px-2 py-2" @click="actionDate('next')">
                                <IconChevronRight :size="18" />
                            </div>
                        </div>
                        <span class="text-lg font-medium">{{ months[monthNow] }} {{ yearNow }}</span>
                        <a-button @click="actionDate('custom', resetDate)">Today</a-button>
                    </div>

                    <div class="flex flex-row gap-2 items-center">
                        <div class="flex flex-row gap-2 items-center">
                            <span v-for="(item, indexCategory) in category"
                                :class="indexCategory === categorySelected ? 'bg-primary text-white' : 'bg-white border text-light'"
                                class="rounded-full font-medium px-4 py-2 gap-2 items-center h-fit flex text-xs cursor-pointer"
                                @click="categorySelected = indexCategory, fetchCalendars()" :key="item">
                                {{ item.name }}
                                <component :stroke-width="1.7" :is="item.icon" :size="18" />
                            </span>
                        </div>
                    </div>
                </div>
            </template>
            
            <template #dateCellRender="{ current }">
                <div v-if="calendars[dayjs(current).format('YYYY-MM-DD')]?.length > 0" class="flex flex-col gap-2">
                    <div v-for="item in calendars[dayjs(current).format('YYYY-MM-DD')]"
                    @click="fetchCalendarDetail(item.id, true, item.type)"
                    :key="item.title"
                        class="w-fit rounded-md px-2 py-1 bg-primary text-white">
                        <span class="text-xs font-semibold">{{ item.title.length > 13 ? `${item.title.slice(0, 13)}...`
                            :
                            item.title }}</span>
                    </div>
                </div>
            </template>
        </a-calendar>

        <a-modal v-model:open="dialogEvent" :width="500" okText="Save" title="Detail Schedule" @ok="dialogEvent = false">
            <div class="py-5 px w-full flex flex-col gap-8">
                <div class="gap-3 flex flex-col w-full">
                    <span class="text-sm font-bold">Event Type</span>
                    <div class="flex flex-row gap-3 items-center text-gray-600">
                        <IconUsers v-if="dialogType === 'mentoring'" :stroke-width="1.8" :size="20" />
                        <IconDeviceTv v-if="dialogType === 'webinar'" :stroke-width="1.8" :size="20" />
                        <span class="text-base">{{ calendarDetail.type }}</span>
                    </div>
                </div>
                <div class="grid grid-cols-2 items-start">
                    <div class="gap-2 flex flex-col w-full">
                        <span class="text-sm font-bold">Date</span>
                        <div class="flex flex-row gap-3 items-center text-gray-600">
                            <IconCalendarMonth :stroke-width="1.8" :size="20" />
                            <span class="text-base">{{ dayjs(calendarDetail.date).format('DD MMM YYYY') }}</span>
                        </div>
                    </div>
                    <div class="gap-2 flex flex-col w-full">
                        <span class="text-sm font-bold">Time</span>
                        <div class="flex flex-row gap-3 items-center text-gray-600">
                            <IconClockHour3 :stroke-width="1.8" :size="20" />
                            <span class="text-base">{{ calendarDetail.time_start }} - {{ calendarDetail.time_end }}</span>
                        </div>
                    </div>
                </div>
                <!-- <div class="gap-3 flex flex-col w-full">
                    <span class="text-sm font-bold">Participant</span>
                    <div class="flex flex-row gap-3 items-center text-gray-600">
                        <a-avatar-group>
                        <a-avatar
                            :src="calendarDetail.startup.photo"
                            :size="40" class="min-w-fit"></a-avatar>
                            <a-avatar
                            :src="calendarDetail.coach.photo"
                            :size="40" class=""></a-avatar>
                            </a-avatar-group>
                    </div>
                </div> -->
                <div class="gap-2 flex flex-col w-full">
                    <span class="text-sm font-bold">Meeting Room</span>
                    <div class="flex flex-row justify-between items-center text-blue-500" @click="openWebinar(calendarDetail.link_room)">
                        <div class="flex flex-row items-start gap-4">
                            <IconLink :stroke-width="1.8" :size="20" />
                            <span class="text-start cursor-pointer">{{ calendarDetail.link_room.slice(0, 30) }}</span>
                            <!-- <a-tooltip placement="top" title="Copy Link"> -->
                            <!-- </a-tooltip> -->
                        </div>
                        <a-button>Join</a-button>
                    </div>
                </div>
            </div>
            <template #footer>
            </template>
        </a-modal>
    </layout-internal-container>
</template>

<script setup>
import { ref, onMounted} from 'vue';
import { IconChevronLeft, IconLink, IconPlus, IconUsers, IconClockHour3, IconChevronRight, IconUser, IconDeviceTv, IconNotes, IconCalendarMonth, IconWall } from '@tabler/icons-vue'
import dayjs from 'dayjs'
import { openWebinar } from "@/plugins/constant.ts"
import { useRoute, useRouter } from 'vue-router'
import axios from "@/plugins/axios";

const router = useRouter()
const route = useRoute()

const dialogType = ref(null)

const months = [
    'January', 
    'February', 
    'March', 
    'April', 
    'May', 
    'June', 
    'July', 
    'August', 
    'September', 
    'October', 
    'November', 
    'December'
]

const resetDate = dayjs()

const value = ref(resetDate);
const monthNow = ref(resetDate.month())
const yearNow = ref(resetDate.year())

const calendars = ref([])
const calendarDetail = ref(null)


const categorySelected = ref('all')

const dialogEvent = ref(false)

const category = ref(
    {
    'all': {
        name: 'All',
        icon: IconWall
    },
    'mentoring': {
        name: 'Mentoring',
        icon: IconUser
    },
    'webinar': {
        name: 'Webinar',
        icon: IconDeviceTv
    }
}
)

const actionDate = (action, current = null) => {
    current = current ?? resetDate

    if (action == 'prev') {
        monthNow.value = monthNow.value - 1

        if (monthNow.value == -1) {
            monthNow.value = 11
            yearNow.value = yearNow.value - 1
        }
    }else if(action == 'next'){
        monthNow.value = monthNow.value + 1

        if (monthNow.value == 12) {
            monthNow.value = 0
            yearNow.value = yearNow.value + 1
        }
    }else{
        monthNow.value = current.month()
        yearNow.value = current.year()
    }

    value.value = dayjs(`${yearNow.value}-${monthNow.value + 1}-${current.date()}`);

    fetchCalendars()
}

const fetchCalendars = async () => {
    const response = await axios.get(`${route.path.toLowerCase().startsWith('/mentor') ? '/mentor' : ''}/calendar/list`, {
        params: {
            type: categorySelected.value,
            month: monthNow.value + 1,
            year: yearNow.value,
        }
    });

    calendars.value = response?.data;
}

const fetchCalendarDetail = async (id, event, type) => {

    const formData = new FormData();

    formData.append('schedule_id', id);
    formData.append('type', type);

    const response = await axios.post(`${route.path.toLowerCase().startsWith('/mentor') ? '/mentor' : ''}/calendar/detail`, formData);

    calendarDetail.value = response?.data;
    
    dialogEvent.value = event;
    dialogType.value = type;
    
    return response?.data.date;
}

const getListData = (value) => {
    let listData;
    switch (value.date()) {
        case 1:
            listData = [
                { color: 'bg-primary text-white', type: 'mentoring', content: 'Mentoring Session With Natali Ardianto' },
                { color: 'bg-primary text-white', content: 'Webinar Week 1', type : 'webinar' },
            ];
            break;
        case 5:
            listData = [
                { color: 'bg-primary text-white',type: 'mentoring', content: 'Mentoring Session With Natali Ardianto' },
                { color: 'bg-primary text-white', content: 'Webinar Week 1', type : 'webinar' },
            ];
            break;
        case 8:
            listData = [
                { color: 'bg-primary text-white',type: 'mentoring', content: 'Mentoring Session With Natali Ardianto' },
                { color: 'bg-primary text-white', content: 'Webinar Week 1', type : 'webinar' },
            ];
            break;
        case 10:
            listData = [
                { color: 'bg-primary text-white',type: 'mentoring', content: 'Mentoring Session With Natali Ardianto' },
                { color: 'bg-primary text-white', content: 'Webinar Week 1', type : 'webinar' },
            ];
            break;
        case 15:
            listData = [
                { color: 'bg-primary text-white',type: 'mentoring', content: 'Mentoring Session With Natali Ardianto' },
                { color: 'bg-primary text-white',type: 'mentoring', content: 'Mentoring Session With Natali Ardianto' },
                { color: 'bg-primary text-white', content: 'Webinar Week 1', type : 'webinar' },
                { color: 'bg-primary text-white', content: 'Webinar Week 1', type : 'webinar' },
            ];
            break;
        case 24:
            listData = [
                { color: 'bg-primary text-white',type: 'mentoring', content: 'Mentoring Session With Natali Ardianto' },
                { color: 'bg-primary text-white',type: 'mentoring', content: 'Mentoring Session With Natali Ardianto' },
                { color: 'bg-primary text-white', content: 'Webinar Week 1', type : 'webinar' },
            ];
            break;
        default:
    }
    return listData || [];
};

onMounted(async () => {
    await fetchCalendars()

    const initCalendarDetail = ['calendarId', 'calendarType'];
    const [id, type] = initCalendarDetail.map(key => sessionStorage.getItem(key));
    
    if (id && type) {
        const dateBooking = await fetchCalendarDetail(id, true, type)
        categorySelected.value = type ?? 'All'

        // console.log(dateBooking)
        actionDate('custom', dayjs(dateBooking))
    }
    
    initCalendarDetail.forEach(key => sessionStorage.removeItem(key));
    
});

</script>
<style scoped>
.events {
    list-style: none;
    margin: 0;
    padding: 0;
}

.events .ant-badge-status {
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    font-size: 12px;
}

.notes-month {
    text-align: center;
    font-size: 28px;
}

.notes-month section {
    font-size: 28px;
}
</style>
  